import type * as React from "react";
import { memo } from "react";
import { IconType } from "~/common/components/icon/IconType";
import { useDispatch } from "react-redux";
import { goToStep } from "../../../../Linear/redux/actions";
import { Link } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconSize } from "~/common/components/icon/IconSize";
import { useTranslation } from "react-i18next";

const EditButton = ({
  index,
  className = "pt-30",
  onStepChange,
}: {
  index: number;
  className?: string;
  onStepChange?: () => void;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    dispatch(goToStep(index));
    onStepChange?.();
  };

  return (
    <Link className={className} onClick={onClick}>
      <Icon className={"icon-margin"} type={IconType.Pencil} size={IconSize.FONT_20} />
      <span>{t("page.linear.summary.btn.edit")}</span>
    </Link>
  );
};

export default memo(EditButton);
